import React, {useEffect, useState} from "react";
import HSort from "../canopia/HSort";
import {search2, sort} from "../canopia/CanopiaUtils";
import {FormGroup} from "react-bootstrap";
import Button from "react-bootstrap/esm/Button";
import {TiDeleteOutline} from "react-icons/ti";
import {PageSelector} from "../core/PageSelector";
import NameTruncWithSearch from "../canopia/NameTruncWithSearch";

export default function FundSubstitutionList(props) {

    const tgtDataOrig = props.tgtDataOrig;

    const initialSortStatus = {
        "fund.fundId": "asc",
        "fund.isin": "asc",
        "fund.name": "asc",
        "fund.lipperStatus": "asc",
        "fund.comment": "asc",
        "type": "asc",
        "fundIsin": "asc",
        "comment": "asc",
        "createdAtFmt": "asc"
    }

    const SEARCH_PROPS = [
        "fund.isin",
        "fund.name",
        "fund.lipperStatus",
        "fund.comment",
        "type",
        "fundIsin",
        "comment",
        "createdAtFmt"
    ];

    const sortAndFilterInitialState = {
        sortStatus: initialSortStatus,
        sortCol: "fund.fundId",
    }

    const [myState, setMyState] = useState({
        tgtData: tgtDataOrig, // The displayed ones, filtered, sorted, ...

        ...sortAndFilterInitialState
    });

    // Pagination
    const PAGE_SIZE = 50;
    const [page, setPage] = useState(1);

    // Search
    const [clearSearchVisibility, setClearSearchVisibility] = useState('hidden');
    const [searchString, setSearchString] = useState('');

    const colorClass = 'canopia2';
    const pfBgClass = 'background-light';
    const borderLeftClassName = 'border-left';
    const colSizeXL = 300;
    const colWidthXL = colSizeXL + 'px';
    const colSizeL = 122;
    const colWidthL = colSizeL + 'px';
    const colSizeM = 80;
    const colWidthM = colSizeM + 'px';
    const colSizeS = 55;
    const colWidthS = colSizeS + 'px';
    const padding = '0.55em 0.5em';

    useEffect(() => {
        // sortFunc(myState.sortCol);
        filter(searchString);
    }, []);

    function sortFunc(colName) {
        const newState = sort({...myState}, colName, initialSortStatus);
        setMyState(newState);
    }

    function changePage(page) {
        setPage(page.key);
    }

    function filter(searchString) {
        let newData = [...tgtDataOrig];

        if (searchString.trim() === "") {
            setClearSearchVisibility("hidden");
        } else {
            if (clearSearchVisibility === "hidden") {
                setClearSearchVisibility("visible");
            }
            newData = search2(searchString, newData, SEARCH_PROPS);
        }

        let newState = {...myState, tgtData: newData};

        newState = sort(newState, newState.sortCol, initialSortStatus, true);

        setMyState(newState);
    }

    // Search category, the component is common to the global and histo view
    const searchCategory = (e) => {
        let searchString = e.target.value;
        searchCat(searchString);
    }

    const resetSearch = () => {
        searchCat('');
    }

    function searchCat(searchString) {
        setSearchString(searchString);
        filter(searchString);
    }

    let searchCategoryInput = <FormGroup controlId="selectView">
        <input value={searchString}
               placeholder="Search fund, source, class..."
               className={'form-control float-left'}
               style={{minWidth: "280px"}}
               aria-label="Search category"
               onChange={searchCategory}
               aria-describedby="basic-addon2"/>
    </FormGroup>;

    let searchCategoryComp;
    const isIE = /*@cc_on!@*/false || !!document.documentMode;
    if (isIE) {
        searchCategoryComp =
            <div style={{display: "flex", flexWrap: "nowrap", marginRight: 'auto'}}>
                {searchCategoryInput}
            </div>
    } else {
        searchCategoryComp = <div style={{display: "flex", flexWrap: "nowrap"}}>
            {searchCategoryInput}
            <Button variant="light" size="sm"
                    style={{
                        marginLeft: 0,
                        padding: 4,
                        borderWidth: '1px 1px 1px 0',
                        borderColor: '#ced4da',
                        borderRadius: '0.25rem .25rem .25rem 0.25rem',
                        visibility: clearSearchVisibility
                    }}
                    onClick={resetSearch}>
                <TiDeleteOutline size={"1.4em"} className={"canopia2"}/>
            </Button>
            {/*<span style={{paddingLeft: '10px', margin: 'auto'}}>{searchString.length > 0 ? searchCount + ' result(s)' : ''}</span>*/}
        </div>
    }

    let rows;
    let effPage = page;
    let tgtData = myState.tgtData;
    if (tgtData && tgtData.length > 0) {

        let startIndex = (effPage - 1) * PAGE_SIZE;
        if (startIndex >= tgtData.length) {
            effPage = 1;
            startIndex = (effPage - 1) * PAGE_SIZE;
        }
        const tgtDataAtPage = tgtData.slice(startIndex, startIndex + PAGE_SIZE);
        rows = tgtDataAtPage.map(subst => {
            return <div key={subst.id} className={"flex-nowrap border-top"}>
                <div className={"setup-col right"} style={{flexBasis: colWidthS, padding: padding}}>
                    {subst.fund.fundId}
                </div>
                <div className={"setup-col"} style={{flexBasis: colWidthL, padding: padding}}>
                    <NameTruncWithSearch name={subst.fund.isin} maxSize={80} search={searchString} wrap={true}/>
                </div>
                <div className={"setup-col"} style={{flexBasis: colWidthXL, padding: padding}}>
                    <NameTruncWithSearch name={subst.fund.name} maxSize={80} search={searchString} wrap={true}/>
                </div>
                <div className={"setup-col"} style={{flexBasis: colWidthL, padding: padding}}>
                    <NameTruncWithSearch name={subst.fund.lipperStatus} maxSize={80} search={searchString} wrap={true}/>
                </div>
                <div className={"setup-col"} style={{flexBasis: colWidthXL, padding: padding}}>
                    <NameTruncWithSearch name={subst.fund.comment} maxSize={80} search={searchString} wrap={true}/>
                </div>
                <div className={"setup-col " + borderLeftClassName} style={{flexBasis: colWidthL, padding: padding}}>
                    <NameTruncWithSearch name={subst.type} maxSize={80} search={searchString} wrap={true}/>
                </div>
                <div className={"setup-col"} style={{flexBasis: colWidthL, padding: padding}}>
                    <NameTruncWithSearch name={subst.fundIsin} maxSize={80} search={searchString} wrap={true}/>
                </div>
                <div className={"setup-col"} style={{flexBasis: colWidthXL, padding: padding}}>
                    <NameTruncWithSearch name={subst.comment} maxSize={80} search={searchString} wrap={true}/>
                </div>
                <div className={"setup-col"} style={{flexBasis: colWidthL, padding: padding}}>
                    <NameTruncWithSearch name={subst.createdAtFmt} maxSize={80} search={searchString} wrap={true}/>
                </div>
            </div>;
        });
    }


    const pageSelector = <PageSelector page={effPage} pageSize={PAGE_SIZE} size={tgtData.length}
                                       clickFunc={changePage}/>;

    return (<>
            <div className={'border-top background-light'} style={{marginTop: "2rem"}}>
                <div className={"flex-nowrap"}>
                    <div className={"setup-th"} style={{flexBasis: "250px"}}>
                        {pageSelector}
                    </div>
                    <div className={"setup-th-input"} style={{flexBasis: "250px"}}>
                        <div>{searchCategoryComp}</div>
                    </div>
                </div>
                <div className={'border-top background-light'}>
                    <div className={"flex-nowrap"}>
                        <div className={"setup-th"} style={{flexBasis: (colSizeS + 2 * colSizeXL + 2 * colSizeL)}}>
                            <b>Fund</b>
                        </div>
                        <div className={"setup-th " + borderLeftClassName} style={{flexBasis: colWidthS}}>
                            <b>Substitution</b>
                        </div>
                    </div>
                </div>
                <div className={'border-top background-light'}>
                    <div className={"flex-nowrap"}>
                        <div className={"setup-th"} style={{flexBasis: colWidthS}}>
                            <HSort label={<b>Id</b>} colName={'fund.fundId'} state={myState} sortFunc={sortFunc}/>
                        </div>
                        <div className={"setup-th"} style={{flexBasis: colWidthL}}>
                            <HSort label={<b>ISIN</b>} colName={'fund.isin'} state={myState} sortFunc={sortFunc}/>
                        </div>
                        <div className={"setup-th"} style={{flexBasis: colWidthXL}}>
                            <HSort label={<b>Name</b>} colName={'fund.name'} state={myState} sortFunc={sortFunc}/>
                        </div>
                        <div className={"setup-th"} style={{flexBasis: colWidthL}}>
                            <HSort label={<b>Lipper Status</b>} colName={'fund.lipperStatus'} state={myState}
                                   sortFunc={sortFunc}/>
                        </div>
                        <div className={"setup-th"} style={{flexBasis: colWidthXL}}>
                            <HSort label={<b>Comment</b>} colName={'fund.comment'} state={myState} sortFunc={sortFunc}/>
                        </div>
                        <div className={"setup-th " + borderLeftClassName} style={{flexBasis: colWidthL}}>
                            <HSort label={<b>Type</b>} colName={'type'} state={myState} sortFunc={sortFunc}/>
                        </div>
                        <div className={"setup-th"} style={{flexBasis: colWidthL}}>
                            <HSort label={<b>ISIN</b>} colName={'fundIsin'} state={myState} sortFunc={sortFunc}/>
                        </div>
                        <div className={"setup-th"} style={{flexBasis: colWidthXL}}>
                            <HSort label={<b>Comment</b>} colName={'comment'} state={myState} sortFunc={sortFunc}/>
                        </div>
                        <div className={"setup-th"} style={{flexBasis: colWidthL}}>
                            <HSort label={<b>Creation</b>} colName={'createdAtFmt'} state={myState}
                                   sortFunc={sortFunc}/>
                        </div>
                    </div>
                </div>
            </div>
            {rows}
        </>
    );
}
